export default "__VITE_ASSET__f5039317__"